import { useState } from "react";
import styles from './UpperContent.module.css';
type props = {
    catName: string
    shortContent: string
}
export function UpperContent({ catName, shortContent }: props) {
    const [fullDesc,setFullDesc] = useState(false);
    return (
        <div className="containerFull">
            <div className={`modularHeading ${styles.readMoreHeading}  ${fullDesc && styles.active}`}>
                <h1 className="mainHeading font24 fontSM20 lineHeight32 lineheightSM3 text000 mb10 f600">{catName}</h1>
                <p className="subHeading font16 fontSM14 text666">{shortContent}</p>
                {(shortContent && shortContent.length > 190 )&& <span onClick={()=>setFullDesc(!fullDesc)}>read {fullDesc ? 'less' : 'more'}</span>}
            </div>
        </div>
    )
}